import {
  Field,
  FieldError,
  FieldLabel,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui";
import type {
  ControllerFieldState,
  ControllerRenderProps,
} from "react-hook-form";

import {
  type AOEAnswerCoding,
  type AOEQuestion,
  AOEQuestionAnswerType,
  isAOEAnswerCoding,
} from "../../../network/useRetrieveAOEForOrder";
import type { AOEFormSchema } from "../schemas";

export const SelectQuestion = ({
  question,
  field,
  fieldState,
  disabled,
}: {
  question: AOEQuestion;
  field: ControllerRenderProps<
    AOEFormSchema,
    `questionnaires.${string}.${string}`
  >;
  fieldState: ControllerFieldState;
  disabled: boolean;
}) => {
  const value = field.value as AOEAnswerCoding | string | undefined;
  const options =
    question.answerOptions?.map((option) => ({
      value: option.valueCoding?.code ?? option.valueString ?? "",
      label: option.valueCoding?.display ?? option.valueString ?? "",
      answerType: option.valueCoding
        ? AOEQuestionAnswerType.CODING
        : AOEQuestionAnswerType.TEXT,
    })) ?? [];

  const handleValueChange = (code: string) => {
    const option = options.find((option) => option.value === code);
    if (option?.answerType === AOEQuestionAnswerType.CODING) {
      field.onChange({
        code,
        display: option.label,
      });
    } else {
      field.onChange(code);
    }
  };

  return (
    <Field data-invalid={fieldState.invalid}>
      <FieldLabel htmlFor={field.name}>
        {question.required && "*"}
        {question.question}
      </FieldLabel>
      <Select
        value={isAOEAnswerCoding(value) ? value.code : (value ?? "")}
        onValueChange={handleValueChange}
        disabled={disabled}
      >
        <SelectTrigger id={field.name} aria-invalid={fieldState.invalid}>
          <SelectValue placeholder="Select an option" />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <FieldError errors={[fieldState.error]} />
    </Field>
  );
};
